/**
 * Admin Overview Tab - Dashboard overview
 */
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

const AdminOverviewTab = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-stone-600">Welcome to the admin panel. Use the tabs above to manage cats, bookings, calendar, donations, and messages.</p>
      </CardContent>
    </Card>
  );
};

export default AdminOverviewTab;
